import React, {useState} from 'react';
import MatchResult from "./MatchResult";

export default function SearchGyms(props) {
	const [search, setSearch] = useState('');
	const [matches, setMatches] = useState([]);
	const textInput = React.createRef();

	const addGym = gym => {
		props.add(gym.id);
		setMatches([]);
		setSearch('');
		textInput.current.focus();
	}

	const onChangeSearch = e => {
		setSearch(e.target.value);
		const search = e.target.value.toLowerCase();
		if( !e.target.value ) {
			setMatches([]);
			return;
		}

		setMatches(props.gyms.filter(gym => gym.name && gym.name.toLowerCase().includes(search)).slice(0,10));
	}

	return (
		<div>
			Add Defender: &nbsp;
			<input ref={textInput} placeholder='Gym Name' type='text' autoFocus value={search} onChange={onChangeSearch} />

			{matches.length > 0 && <blockquote>
				{matches.map(gym => <MatchResult gym={gym} add={addGym} />)}
			</blockquote>}
		</div>
	);
};
